import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import i18next from '../i18n.js';
pdfjs.GlobalWorkerOptions.workerSrc = '/dist/react-pdf/pdf.worker.min.mjs';

const re = /[0-9]/gi;
const minScale = 25;
const maxScale = 500;
const scaleStep = 10;
const pdfViewerPadding = 76;
const maxScaleWinWidth = 721;

const PdfViewer = (props) => {
    const [numPages, setNumPages] = useState(null);
    const [scale, setScale] = useState(100);
    const [bufferScale, setBufferScale] = useState('100%');
    const timerId = useRef(null);

    useEffect(() => {
        let newScale = Math.floor(((window.outerWidth - pdfViewerPadding) / (maxScaleWinWidth - pdfViewerPadding)) * 100);
        if (newScale < minScale) newScale = minScale;
        if (newScale > 100) newScale = 100;
        setScale(newScale);
        setBufferScale(newScale + '%');
    }, []);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const onScaleUp = (e) => {
        e.preventDefault();
        const newScale = scale + scaleStep;
        if (newScale <= maxScale) {
            setScale(newScale);
            setBufferScale(newScale + '%');
        }
    }

    const onScaleDown = (e) => {
        e.preventDefault();
        const newScale = scale - scaleStep;
        if (newScale >= minScale) {
            setScale(newScale);
            setBufferScale(newScale + '%');
        }
    }

    const onScaleChanged = (e) => {
        setBufferScale(e.target.value);
        let newValue = e.target.value;
        if (newValue.endsWith('%')) {
            newValue = newValue.split('%')[0];
        }
        if (re.test(newValue)) {
            let newScale = Number(newValue);
            if (newScale >= minScale && newScale <= maxScale) {
                if (timerId.current !== null) {
                    clearTimeout(timerId.current);
                }
                timerId.current = setTimeout(() => {
                    timerId.current = null;
                    setScale(newScale);
                }, 1000);
            }
        }
    }

    const applyBufferScale = () => {
        let newValue = bufferScale;
        if (newValue.endsWith('%')) {
            newValue = newValue.split('%')[0];
        }
        if (re.test(newValue)) {
            let newScale = Number(newValue);
            if (newScale < minScale) newScale = minScale;
            if (newScale > maxScale) newScale = maxScale;
            setScale(newScale);
            setBufferScale(newScale + '%');
        }
        else {
            setBufferScale(scale + '%');
        }
    }

    return (
        <div className="pdf-viewer">
            <div className="pdf-viewer__settings">
                <button onClick={onScaleDown}>–</button>
                <input value={bufferScale} onChange={onScaleChanged} onBlur={applyBufferScale} onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur() }} />
                <button onClick={onScaleUp}>+</button>
            </div>
            <div className="pdf-viewer__body scrollYInner">
                <Document file={props.src} onLoadSuccess={onDocumentLoadSuccess}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page key={`page_${index + 1}`} scale={scale / 100} pageIndex={index} loading={i18next.t("pageLoading")} />
                    ))}
                </Document>
            </div>
        </div>
    );
};

export default PdfViewer;
